import React from 'react';
import { Redirect } from 'react-router-dom';
import '../../../index.scss';
const HomePage = props => {
  const { isAuthenticated } = props.authContext;
  return <Redirect to={'/login'} />;
};

export default HomePage;
